const walletGrowthLabel = (balances, key) => {
  const currentMonth = new Date().getMonth();
  if (currentMonth === 0 || balances.length < 2) return null;
  const prev = balances[currentMonth - 1][key];
  const curr = balances[currentMonth][key];
  if (prev === 0 && curr === 0) return null;
  if (prev === 0) return '+100% From last month';
  const pct = Math.round(((curr - prev) / prev) * 100);
  return pct >= 0
    ? `+${pct}% From last month`
    : `${pct}% From last month`;
};

export const walletChartData = (balances, key) =>
  balances.map(({ month, [key]: total }) => ({ month, total }));

export default walletGrowthLabel;
